<div class="color-circle">
  <div class="base-color" [style.--circle-color]="colorHex">
    <div class="shade-color" [style.--shade-color]="shadeColor"></div>
  </div>
</div>
